import { POSTHOG_PROXY_HOST_AI, POSTHOG_PROXY_HOST_DEV } from "../../constants/buildFlags";

const PROXY_HOST_BY_APEX_DOMAIN: Record<string, string> = {
  "paribus.dev": POSTHOG_PROXY_HOST_DEV,
  "paribus.ai": POSTHOG_PROXY_HOST_AI,
};

/**
 * Picks the PostHog proxy host matching the page's registrable domain
 * (eTLD+1) — required for same-site cookies / anti-ad-blocker cloaking to
 * work, and why this can't be a single static env var for both apex domains.
 */
export function getPostHogApiHost(hostname: string, fallbackHost: string): string {
  for (const [apexDomain, proxyHost] of Object.entries(PROXY_HOST_BY_APEX_DOMAIN)) {
    if (hostname === apexDomain || hostname.endsWith(`.${apexDomain}`)) {
      return proxyHost;
    }
  }

  return fallbackHost;
}
